/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The possible component output html static file cross origin types.
 * @export
 */
export type ComponentOutputHtmlStaticFileCrossOriginType =
  | ComponentOutputHtmlStaticFileCrossOriginTypeAnonymous
  | ComponentOutputHtmlStaticFileCrossOriginTypeUseCredentials;

/**
 * The html static file anonymous cross origin type.
 * @export
 */
export type ComponentOutputHtmlStaticFileCrossOriginTypeAnonymous =
  typeof COMPONENT_OUTPUT_HTML_STATIC_FILE_CROSS_ORIGIN_TYPE_ANONYMOUS;

/**
 * The html static file use-credentials cross origin type.
 * @export
 */
export type ComponentOutputHtmlStaticFileCrossOriginTypeUseCredentials =
  typeof COMPONENT_OUTPUT_HTML_STATIC_FILE_CROSS_ORIGIN_TYPE_USE_CREDENTIALS;

/**
 * The html static file anonymous cross origin constant.
 * @export
 */
export const COMPONENT_OUTPUT_HTML_STATIC_FILE_CROSS_ORIGIN_TYPE_ANONYMOUS = 'anonymous';

/**
 * The html static file use-credentials cross origin constant.
 * @export
 */
export const COMPONENT_OUTPUT_HTML_STATIC_FILE_CROSS_ORIGIN_TYPE_USE_CREDENTIALS = 'use-credentials';
